import type { DeleteIngestionConfigMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteIngestionConfigDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface DeleteIngestionConfigInput {
  Id: string;
}

/**
 * The tRPC delete returns `void` (204); the GraphQL mutation echoed back the
 * deleted `Id`. Reconstruct that shape from the input so consumers branching
 * on the result do not need to know which path executed.
 */
export const useDeleteIngestionConfig = createMutationHook({
  name: 'deleteIngestionConfig',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.ingestionConfig.delete.mutationOptions({ onSuccess }),
  mapInput: (input: DeleteIngestionConfigInput) => ({ Id: input.Id }),
  invalidate: (trpc) => [trpc.frontend.ingestionConfig.getAll.queryKey()],
  mapResponse: (
    _result,
    input: DeleteIngestionConfigInput
  ): DeleteIngestionConfigMutation => ({
    deleteChildIngestionConfig: {
      __typename: 'IdOutput',
      Id: input.Id,
    },
  }),
  graphqlDocument: DeleteIngestionConfigDocument,
  graphqlVariables: (input: DeleteIngestionConfigInput) => ({
    object: { Id: input.Id },
  }),
  evictFields: ['ingestion_config'],
});
